import { GET_TRANSACTIONS_HISTORY, GET_ETH_USD_RATE, GET_DERIVED_ETH_RATE } from '../../apollo/queries';
import { graphEndpoint } from '../../helper/subgraphs';
import axios from 'axios';
import { ethers } from 'ethers';
import { shortenDouble } from '../../utils';

interface Coordinates {
  __typename: string;
  x: number;
  y: number;
}

interface LandInfo {
  __typename: string;
  id: string;
  coordinates: Coordinates;
  owner: string;
  price: string;
  isBoughtWithShib: boolean;
  usd_price?: string; // Optional, as it's added later
  shib_usd_price?: string; // Optional, as it's added later
}

export const GetTransactions = async ({ wallet, chain }: { wallet: string, chain: number }) => {
  try {
    const transactionHistoryEndpoint = graphEndpoint(true);
    const response = await axios.post(transactionHistoryEndpoint, {
      query: GET_TRANSACTIONS_HISTORY(wallet)
    });
    if (response.data.data.landInfos.length > 0) {
      const ETH_USD_ConversionEndpoint = graphEndpoint(false, chain, true);
      const SHIB_USD_ConversionEndpoint = graphEndpoint(false, chain, true);
      const ETH_USD_RATE = await axios.post(ETH_USD_ConversionEndpoint, {
        query: GET_ETH_USD_RATE
      });
      const ethPriceInUSD = parseFloat(ETH_USD_RATE.data.data.bundleById.ethPrice);
      const SHIBderivedETH_RATE = await axios.post(SHIB_USD_ConversionEndpoint, {
        query: GET_DERIVED_ETH_RATE
      });
      const derivedETH = parseFloat(SHIBderivedETH_RATE.data.data.tokenById.derivedETH);
      const shibPriceInUSD = (derivedETH / 18) * ethPriceInUSD;
      const updatedLandInfos = response.data.data.landInfos.map((landInfo: LandInfo) => {
        if (landInfo.isBoughtWithShib) {
          const shibAmount = parseFloat(landInfo.price);
          const usdPrice = shibAmount * shibPriceInUSD;
          return {
            ...landInfo,
            price: shortenDouble(Number(ethers.formatEther(landInfo.price)), 2),
            shib_usd_price: usdPrice.toFixed(2) // Format to 2 decimal places
          };
        } else {
          const ethAmount = parseFloat(landInfo.price);
          const usdPrice = ethAmount * ethPriceInUSD;
          return {
            ...landInfo,
            price: ethers.formatEther(landInfo.price),
            usd_price: usdPrice.toFixed(2) // Format to 2 decimal places
          };
        }
      });

      return updatedLandInfos;
    }
    return response.data.data.landInfos;
  } catch (error) {
    throw error;
  }
};
